import { render, staticRenderFns } from "./DetailCustomer.vue?vue&type=template&id=060640c6&scoped=true"
import script from "./DetailCustomer.vue?vue&type=script&lang=js"
export * from "./DetailCustomer.vue?vue&type=script&lang=js"
import style0 from "./DetailCustomer.vue?vue&type=style&index=0&id=060640c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060640c6",
  null
  
)

export default component.exports